import { apiClient, formatQueryString } from "../apiClient"

export const TIEN_THUA_HOC_SINH_API_RESOURCE = "tien-thua-hoc-sinh"
export const tienThuaHocSinhApi = {
    SelectAll: (params?: { dm_coso_id?: number }) => {
        const query = params ? formatQueryString(params) : "";
        return apiClient.get(`${TIEN_THUA_HOC_SINH_API_RESOURCE}${query ? `?${query}` : ""}`);
    },
    SelectByHocSinh: (ts_hocsinh_id: number) => apiClient.get(`${TIEN_THUA_HOC_SINH_API_RESOURCE}/hoc-sinh/${ts_hocsinh_id}`)
}
